// This file outlines where cloud-hosted assets are dynamically added to the page, if possible.

import { injectIfMissing } from "./ui-core";

export function tryAttachExternalDependencies() {
	// Font Awesome 6-: f68b92a404
	// Font Awesome 7+: 23f0849ae8
	injectIfMissing({
		type: "script",
		url: "https://kit.fontawesome.com/23f0849ae8.js",
		search: "kit.fontawesome.com",
		attributes: { crossorigin: "anonymous" }
	});

	injectIfMissing({
		type: "link",
		url: "https://use.typekit.net/hht4brb.css",
		search: "use.typekit.net",
		attributes: { media: "all" }
	});
}
